import { AdvisoryContent } from '../common/global-types/AdvisoryContent';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { createRoot } from 'react-dom/client';
import AdvisoryTypeSelector from './types/AdvisoryTypeSelector';
import config from '../config';

class AdvisoryWebElement extends HTMLElement {
  private shadow: ShadowRoot;
  private content: AdvisoryContent[] | undefined;

  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    try {
      this.initializeComponent();
    } catch {
      window.applicationInsights.trackTrace({
        message: 'Unknown error occurred during initializeComponent',
        severityLevel: SeverityLevel.Error,
      });
    }
  }

  initializeComponent() {
    const fonts = document.createElement('style');
    fonts.textContent = `
        @font-face {
          font-family: 'If Sans Variable';
          src: 
            url('https://static.design.if.eu/ids-font/IfSans-Variable.woff2') format('woff2'),
            url('https://static.design.if.eu/ids-font/IfSans-Variable.woff') format('woff'),
            url('https://static.design.if.eu/ids-font/IfSans-Variable.ttf') format('truetype');
        }

        advisory-recommendation {
          height: 100%;
          display: flex;
          flex-direction: column;
        }
      `;
    this.appendChild(fonts);

    this.loadContent();

    if (this.content?.length === 0) return;

    this.renderComponent();
  }

  loadContent() {
    const element = document.getElementById(config.ADVISORY_RECEIVED_DATA_SCRIPT_ID);

    if (!element || !element.textContent) return;

    this.content = JSON.parse(element.textContent);
  }

  renderComponent() {
    const root = createRoot(this.shadow);
    root.render(
      <>
        <link rel="stylesheet" href="https://static.design.if.eu/ids-style-scaffolding/18.35.1-4/scaffolding.css" />
        <link rel="stylesheet" href="https://static.design.if.eu/ids-style/18.35.1-4/ifdesignsystem.min.css" />
        <link rel="stylesheet" href={`${import.meta.env.VITE_BASE_PATH}/${import.meta.env.VITE_CSS_PATH!}`} />
        <AdvisoryTypeSelector advisoryContent={this.content?.filter((ac) => ac.instance === this.id)}/>
      </>
    );
  }
}

export default AdvisoryWebElement;
